import { ADD_USER_REQUEST, ADD_USER_SUCCESS, ADD_USER_FAILURE } from '../constants/add_user.constants';

export const addUserRequest = params => ({
    type: ADD_USER_REQUEST, params,
});

export const addUserRequestSuccess = payload => ({
    type: ADD_USER_SUCCESS, payload,
});

export const addUserRequestFailure = error => ({
    type: ADD_USER_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/redux/actions/add_user.actions.js